export default 9.01